import type { GeneratedQuestion } from '../generators/math/types';

interface ChineseBank {
  kp: string;
  textbook: string;
  grade: number;
  semester: number;
  questions: (GeneratedQuestion & { surfaceVariant: string })[];
}

let cached: ChineseBank | null = null;

export async function loadChineseZhuyinBank(): Promise<ChineseBank> {
  if (cached) return cached;
  const resp = await fetch('/data/chinese-zhuyin-康軒.json');
  if (!resp.ok) throw new Error(`Failed to load Chinese bank: ${resp.status}`);
  cached = (await resp.json()) as ChineseBank;
  return cached;
}

/**
 * Sample N questions ensuring no two share the same surfaceVariant.
 * Falls back to allowing duplicates only if not enough variants.
 */
export function sampleBank(bank: ChineseBank, n: number): GeneratedQuestion[] {
  const shuffled = [...bank.questions].sort(() => Math.random() - 0.5);
  const used = new Set<string>();
  const out: GeneratedQuestion[] = [];
  for (const q of shuffled) {
    if (out.length >= n) break;
    const variant = q.surfaceVariant;
    if (used.has(variant)) continue;
    used.add(variant);
    out.push(q);
  }
  // If we couldn't fill n with unique variants, fill from remaining
  if (out.length < n) {
    for (const q of shuffled) {
      if (out.length >= n) break;
      if (!out.includes(q)) out.push(q);
    }
  }
  return out;
}
